import React from "react";
import toastTickIcon from "../../assets/images/Perps/toasttick.svg";
import "./CustomToast.css";

const SuccessIcon = () => (
  <img src={toastTickIcon} alt="success" width={40} height={40} />
);

const ErrorIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="10" fill="#E73639"/>
    <path d="M14 14L26 26" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 26L26 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CloseButton = ({ closeToast, type }) => {
  const isError = type === "error" || type === "warning";
  const color = isError ? "#E73639" : "#229564";

  // Circle params: r=13, circumference = 2 * PI * 13 ≈ 81.68
  const circumference = 2 * Math.PI * 13;

  return (
    <button onClick={closeToast} className="custom-toast-close-btn">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Background circle (track) */}
        <circle cx="16" cy="16" r="13" stroke={color} strokeWidth="1.5" strokeOpacity="0.2" fill="none" />
        {/* Animated countdown ring */}
        <circle
          cx="16" cy="16" r="13"
          stroke={color}
          strokeWidth="1.5"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset="0"
          className="toast-countdown-ring"
          style={{
            transformOrigin: "center",
            transform: "rotate(-90deg)",
          }}
        />
        {/* X icon */}
        <path d="M12 12L20 20" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 20L20 12" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
};

export const getToastIcon = ({ type, isLoading }) => {
  if (isLoading) return <SuccessIcon />;
  switch (type) {
    case "success":
    case "info":
    case "default":
      return <SuccessIcon />;
    case "error":
    case "warning":
      return <ErrorIcon />;
    default:
      return <SuccessIcon />;
  }
};

export { CloseButton };
